//#region Insights
import { UATConstants } from '../Common/Models/UATConstants';
import { store, StoreState } from '../Store';
import { getWindowLocationHref } from './BrowserGlobals';

export const GetUserAppInsightProperties = (): any => {
  const storeState = store.getState() as StoreState;
  const userProfile = storeState.userProfile;
  return {
    UserName: userProfile.displayName,
    Email: userProfile.email,
    AppName: 'UAT',
    AppLayer: 'UAT-UI',
    AppId: UATConstants.ClientId,
  };
};

export const GetOLFLoggingAppInsightProperties = (details: any, url: any): any => {
  const storeState = store.getState() as StoreState;
  const userProfile = storeState.userProfile;
  const webAPIUrl = UATConstants.OLFWebApiUrl;
  const urlToUse: string = url.startsWith('/api/', 0) ? webAPIUrl.concat(url) : url;
  return {
    requestedByUserName: userProfile.displayName,
    requestedByUserAlias: userProfile.email,
    WebAPIUrl: urlToUse,
    WebUIURL: getWindowLocationHref(),
    MissingDetails: details,
  };
};

export const GetViewInsightProperties = (viewName: string, toViewName: string): any => {
  const storeState = store.getState() as StoreState;
  const userProfile = storeState.userProfile;
  return {
    UserName: userProfile.displayName,
    Email: userProfile.email,
    viewName: viewName,
    toViewName: toViewName,
  };
};
//#endregion

export const getCommentSummary = async (actionId: number) => {
  try {
    // Initialize memory cache if not exists
    if (!window.uatCommentSummaryCache) {
      window.uatCommentSummaryCache = {};
    }

    // Check memory cache first
    const cacheKey = `comment_summary_${actionId}`;
    const now = Date.now();
    const cached = window.uatCommentSummaryCache[cacheKey];

    if (cached && now - cached.timestamp < 300000) {
      return cached.data;
    }

    const tokenFromSession = sessionStorage.getItem(UATConstants.jwtTokenForApi);
    const body = {
      AppName: 'UAT',
      Id: `${actionId}`,
    };
    const url = UATConstants.CommonServicesWebApiUrl + '/api/v1/GPTTurnKey/CommentSummary';

    // Add timeout with AbortController
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort();
    }, 10000);

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        Authorization: `Bearer ${tokenFromSession}`,
        'Content-type': 'application/json',
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (response.status === 200) {
      const json = await response.json();
      const result = json && (Array.isArray(json) ? json.length > 0 : Object.keys(json).length > 0);

      // Cache the result in memory
      window.uatCommentSummaryCache[cacheKey] = {
        data: result,
        timestamp: now,
      };

      return result;
    }

    return false;
  } catch (err) {
    if (err.name === 'AbortError') {
      console.warn(`[UAT Performance] CommentSummary request aborted for action ${actionId}`);
    } else {
      console.error('Error fetching comment summary:', err);
    }
    return false;
  }
};

/**
 * Clear all UAT caches
 */
export const clearAllUATCaches = (): void => {
  if (window.uatCommentSummaryCache) {
    window.uatCommentSummaryCache = {};
    console.log('[UAT Performance] Cleared comment summary cache');
  }

  if (window.uatSeedingQuestionsCache) {
    window.uatSeedingQuestionsCache = {};
    console.log('[UAT Performance] Cleared seeding questions cache');
  }

  if (window.uatMilestoneDataCache) {
    window.uatMilestoneDataCache = {};
    console.log('[UAT Performance] Cleared milestone data cache');
  }

  console.log('[UAT Performance] All caches cleared');
};
